import axios from 'axios';
import { handleRateLimitError } from '../utils/rateLimitHandler';

// Use relative URL '/api' in production (when REACT_APP_API_URL is not set)
// This allows the client to connect to the API on the same origin
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Create axios instance for unauthenticated requests (e.g., registration, password reset)
const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Handle rate limiting errors for unauthenticated requests
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle rate limiting errors (429)
    if (error.response?.status === 429) {
      return Promise.reject(handleRateLimitError(error));
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
